import { useQuery } from '@tanstack/react-query'
import getReportTemplates from '../../services/ruutsApi/reports/getReportTemplates'
import { queryKeys } from './queryKeys'

// Templates are static per-deploy files, so once fetched they never need to refetch
// for the lifetime of the session.
export const useReportTemplates = () =>
  useQuery({
    queryKey: queryKeys.reportTemplates(),
    queryFn: ({ signal }) => getReportTemplates({ signal }),
    staleTime: Infinity,
  })
